import { render, staticRenderFns } from "./TabDashboard.vue?vue&type=template&id=02206d65&scoped=true&"
import script from "./TabDashboard.vue?vue&type=script&lang=js&"
export * from "./TabDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02206d65",
  null
  
)

export default component.exports